<template>
  <v-card
    v-if="settings && settings.unpaid_wl_usage_invoices > 0"
    :color="'warning'"
    style="border-radius:0;"
  >
    <center>
      <v-icon
        style="margin: -4px 7px 0 0; font-size:18px;"
        :class="settings.overdue_wl_usage_invoices > 0 ? 'blink text-negative' : ''"
      >
        mdi-lightbulb-on-outline
      </v-icon>
      <span
        v-if="settings.overdue_wl_usage_invoices == 0"
      >{{ $t('invoices.unpaidInvoices') }}
        <b>
          <router-link to="/myinvoices">
            {{ $t('invoices.viewInvoices') }}
          </router-link>
        </b>
      </span>
      <span
        v-else
      >{{ $t('invoices.overdueInvoices') }}
        <b>
          <router-link to="/myinvoices">
            {{ $t('invoices.viewInvoices') }}
          </router-link>
        </b>
      </span>
    </center>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  data: () => ({
    settings: null
  }),
  computed: {
    ...mapGetters("user", ["getUserSettings"]),
  },
  mounted() {
    store.subscribe((mutation, state) => {
      if (mutation.type == "user/setUserSettings") {
        this.settings = state.user.userSettings
      }
    });
  }
};
</script>

<style>
</style>
